import { normalizeRefineParameter } from "./normalizeRefineParameter";
import getNormalizedRefineForSeoImportantFacetConfig from "./getNormalizedRefineForSeoImportantFacetConfig";

const getMatchedSeoImportantFacet = ({ seoImportantFacets, refine }) => {
  if (!refine || !seoImportantFacets) {
    return undefined;
  }

  const normalizedRefine = normalizeRefineParameter({ refine });

  return seoImportantFacets.find((facet) => {
    const normalizedQuery =
      getNormalizedRefineForSeoImportantFacetConfig(facet);

    return normalizedQuery === normalizedRefine;
  });
};

export default getMatchedSeoImportantFacet;
